import * as React from 'react';
import debounce from 'debounce';

import { inject, observer } from 'mobx-react';
import { Tabs, TabsItem } from 'telia-front-react';

import TranslateStore from '@stores/TranslateStore';
import TabStore from '@stores/TabStore';
import RouteStore from '@stores/RouteStore';
import { DisturbanceTabId } from '@config/DisturbanceConfig';
import { FilterState } from '@config/DisturbanceFilter';
import { removeEmptyKeys } from '@util/ApiUtil';

interface DisturbanceTabsProps {
  changes: React.ReactNode;
  incidents: React.ReactNode;
  problems: React.ReactNode;
  filter: FilterState;
  translateStore?: TranslateStore;
  tabStore?: TabStore;
  routeStore?: RouteStore;
}

@inject('changes', 'incidents', 'problems', 'filter', 'translateStore', 'tabStore', 'routeStore')
@observer
export default class DisturbanceTabs extends React.Component<DisturbanceTabsProps> {
  private fetchTabs = debounce(async (filter: FilterState): Promise<void> => {
    const { tabStore } = this.props;
    await tabStore.fetchTabs(filter);
  }, 500);

  public async componentDidUpdate(prevProps: DisturbanceTabsProps) {
    const { filter } = this.props;
    const filterNew = JSON.parse(JSON.stringify(filter));
    if (prevProps.filter && this.compareFilterObject(filterNew, prevProps.filter)) {
      await this.fetchTabs(filterNew);
    }
  }

  private compareFilterObject(filter: FilterState, prevFilter: FilterState) {
    let filterPrev = JSON.parse(JSON.stringify(prevFilter));
    const filterNew = removeEmptyKeys(filter);
    filterPrev = removeEmptyKeys(filterPrev);
    return JSON.stringify(filterNew) !== JSON.stringify(filterPrev);
  }

  public render(): JSX.Element {
    const {
      changes,
      incidents,
      problems,
      filter,
      translateStore: { translate },
      tabStore: { tabs, currentTab, setTab }
    } = this.props;

    return currentTab ? (
      <Tabs
        size="huge"
        fullWidth={true}
        aria-labelledby={translate('filter.type')}
        currentTab={currentTab.toString()}
        onTabChange={async ({}, nextTab) => await setTab(nextTab, filter)}
      >
        <TabsItem id={DisturbanceTabId.INCIDENT} tagContent={tabs?.incidents} label={translate('general.incidents')}>
          {incidents}
        </TabsItem>
        <TabsItem id={DisturbanceTabId.PROBLEM} type="employee" tagContent={tabs?.problems} label={translate('general.problems')}>
          {problems}
        </TabsItem>
        <TabsItem id={DisturbanceTabId.CHANGE} tagContent={tabs?.changes} label={translate('general.changes')}>
          {changes}
        </TabsItem>
      </Tabs>
    ) : (
      <></>
    );
  }
}
